import React from "react";
import { Outlet } from "react-router-dom";
import SideBar from "../layout/sidebar/SideBar";
import Footer from "../layout/footer/Footer";
import ErrorBoundary from "../error-boundary";
import AppErrorFallback from "../error-boundary/fallback/AppErrorFallback";

export default function SidebarLayout() {
  return (
    <ErrorBoundary fallback={<AppErrorFallback />}>
      <SideBar>
        <Outlet />
      </SideBar>
      <Footer />
    </ErrorBoundary>
  );
}
